export default {
  setSettingEntity(state, value) {
    state.settingEntity = value
  },
  setCompanySettings(state, data) {
    state.companySettings = data
  },
  setCompanyRatingMin(state, value) {
    let currentKeyVote = 0
    _.forEach(state.companySettings.rating_rules, (rule, key) => {
      if (rule.if.vote_avg_less) {
        currentKeyVote = key
      }
    })
    state.companySettings.rating_rules[currentKeyVote].if.vote_avg_less = value
  },
  setCompanyBlockAfter(state, value) {
    state.companySettings.rating_block_after = value
  },
  setCompanyBlockAt(state, value) {
    state.companySettings.rating_block_at = value
  },
  setSelectedTypeBlocking(state, value) {
    state.selectedTypeBlocking = value
  },
  setCertificationRatingMin(state, value) {
    state.companySettings.certification_min_score = value
  },
  setCompanyRatingMin123(state, value) {
    state.companySettings.rating_min123 = value
  },
  setCompanyRebooking(state, value) {
    state.companySettings.rebook_after = value
    state.companySettings.rebook_before = value
  },
}
